import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Solicitação', flex: 1.5, orderValue: 'requestDate' },
  { title: 'Tipo', flex: 1, orderValue: 'offerType' },
  { title: 'Cliente', flex: 1.5, orderValue: 'clientName' },
  { title: 'Produto', flex: 1.5, orderValue: 'companyName' },
  { title: 'Valor', flex: 1, orderValue: 'offerValue' },
  { title: 'Status', flex: 1, orderValue: 'statusDescription' },
];
